module.exports = __webpack_public_path__ + "media/images/gba/2019/v2/sg/sg_c_blanco-75c145f639f169dacc436151d025e3fc.svg";